<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Options"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
      {
        text: 'Reservas y estadías',
        disabled: false,
        href: '/admin/options'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider
                ref="option"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Opción</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.option"
                  label="Ingrese aquí la opción"
                  solo
                  hide-details="auto"
                  class="input-base"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: (state) => state.Options.status,
    }),
  },
  data() {
    return {
      storeName: "Options",
      title: "Opciones",
      data: {
        option: "",
      },
    };
  },
};
</script>
